/**
 * @flow
 * @relayHash 72507c2a53bf14bd3a0838cee4bf6a02
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TopBarFreelancerNotification_notifications$ref = any;
export type TopBarFreelancerNotificationRefetchQueryVariables = {|
  unread?: ?boolean,
  first: number,
  after?: ?string,
|};
export type TopBarFreelancerNotificationRefetchQueryResponse = {|
  +$fragmentRefs: TopBarFreelancerNotification_notifications$ref
|};
export type TopBarFreelancerNotificationRefetchQuery = {|
  variables: TopBarFreelancerNotificationRefetchQueryVariables,
  response: TopBarFreelancerNotificationRefetchQueryResponse,
|};
*/


/*
query TopBarFreelancerNotificationRefetchQuery(
  $unread: Boolean
  $first: Int!
  $after: String
) {
  ...TopBarFreelancerNotification_notifications_Fa6ey
}

fragment TopBarFreelancerNotification_notifications_Fa6ey on Query {
  notifications(unread: $unread, first: $first, after: $after) {
    totalCount
    edges {
      node {
        id
        unread
        timesince
        description
        actor {
          name
          representativeImageUrl
          actorType
        }
        extraData {
          targetRelayId
          actionRelayId
          content
          notificationType
          instanceType
          instanceTitle
          action
        }
        reviewAssetComment {
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "unread",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "unread",
    "variableName": "unread"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "TopBarFreelancerNotificationRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "TopBarFreelancerNotification_notifications",
        "args": (v1/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TopBarFreelancerNotificationRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "notifications",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "NotificationNodeConnection",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "NotificationNodeEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "NotificationNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "unread",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "timesince",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "actor",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "NotificationActorNode",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "representativeImageUrl",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "actorType",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "extraData",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "NotificationExtraData",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "targetRelayId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "actionRelayId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "content",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "notificationType",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "instanceType",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "instanceTitle",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "action",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "reviewAssetComment",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CommentNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "notifications",
        "args": (v1/*: any*/),
        "handle": "connection",
        "key": "TopBarFreelancerNotification_notifications",
        "filters": [
          "unread"
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "TopBarFreelancerNotificationRefetchQuery",
    "id": null,
    "text": "query TopBarFreelancerNotificationRefetchQuery(\n  $unread: Boolean\n  $first: Int!\n  $after: String\n) {\n  ...TopBarFreelancerNotification_notifications_Fa6ey\n}\n\nfragment TopBarFreelancerNotification_notifications_Fa6ey on Query {\n  notifications(unread: $unread, first: $first, after: $after) {\n    totalCount\n    edges {\n      node {\n        id\n        unread\n        timesince\n        description\n        actor {\n          name\n          representativeImageUrl\n          actorType\n        }\n        extraData {\n          targetRelayId\n          actionRelayId\n          content\n          notificationType\n          instanceType\n          instanceTitle\n          action\n        }\n        reviewAssetComment {\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '08499cac4cd71b17bf36979ace8c18d6';
module.exports = node;
